<template>
  <div class="ele-body">
    <el-card shadow="never" v-loading="loading" body-style="padding-bottom: 0;">
      <el-row :gutter="15">
        <el-col :md="6" style="margin-bottom: 15px;">
          <!-- 操作按钮 -->
          <div class="ele-table-tool ele-table-tool-default">
            <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加
            </el-button>
            <el-button @click="edit" type="warning" icon="el-icon-edit" class="ele-btn-icon" :disabled="!current"
                       size="small">修改
            </el-button>
            <el-button @click="remove" type="danger" icon="el-icon-delete" class="ele-btn-icon" :disabled="!current"
                       size="small">删除
            </el-button>
          </div>
          <!-- 机构列表 -->
          <div class="org-tree-group">
            <el-tree ref="orgTree" :data="data" :props="{label:'name'}" :expand-on-click-node="false"
                     node-key="id" :default-expand-all="true" @node-click="choose" highlight-current/>
          </div>
        </el-col>
        <el-col :md="18" style="margin-bottom: 15px;">
          <user-list v-if="current" :dept-id="current.id" :dept-list="deptList"/>
        </el-col>
      </el-row>
    </el-card>
    <!-- 编辑弹窗 -->
    <el-dialog :title="editForm.id?'修改机构':'添加机构'" :visible.sync="showEdit" width="600px"
               @closed="editForm={}" :destroy-on-close="true" custom-class="ele-dialog-form" :lock-scroll="false">
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="82px">
        <el-row :gutter="15">
          <el-col :sm="12">
            <el-form-item label="上级机构:">
              <treeselect v-model="editForm.pid" :options="deptList"
                          placeholder="请选择上级机构" :defaultExpandLevel="4"
                          :normalizer="(d)=>{return { id: d.id, label: d.name }}"/>
            </el-form-item>
            <el-form-item label="机构名称:" prop="name">
              <el-input v-model="editForm.name" placeholder="请输入机构名称" clearable/>
            </el-form-item>
            <el-form-item label="机构全称:" prop="fullname">
              <el-input v-model="editForm.fullname" placeholder="请输入机构全称" clearable/>
            </el-form-item>
            <el-form-item label="机构代码:" prop="code">
              <el-input v-model="editForm.code" placeholder="请输入机构代码" clearable/>
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item label="机构类型:" prop="type">
              <el-select v-model="editForm.type" placeholder="请选择机构类型" class="ele-fluid" clearable>
                <el-option v-for="(item,index) in typeList" :key="index"
                           :label="item.name" :value="item.id"/>
              </el-select>
            </el-form-item>
            <el-form-item label="排序号:" prop="sort">
              <el-input-number v-model="editForm.sort" controls-position="right" :min="0"
                               placeholder="请输入排序号" class="ele-fluid ele-text-left"/>
            </el-form-item>
            <el-form-item label="备注:">
              <el-input v-model="editForm.note" placeholder="请输入备注" :rows="4" type="textarea"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit=false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'  // 下拉树
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import UserList from './user-list'

export default {
  name: "SysOrganization",
  components: {UserList, Treeselect},
  data() {
    return {
      loading: true,  // 加载状态
      data: [],  // 列表数据
      where: {},  // 搜索条件
      current: null,  // 选中数据
      showEdit: false,  // 是否显示表单弹窗
      editForm: {},  // 表单数据
      editRules: {  // 表单验证规则
        name: [
          {required: true, message: '请输入机构名称', trigger: 'blur'}
        ],
        fullname: [
          {required: true, message: '请输入机构全称', trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入机构代码', trigger: 'blur'}
        ],
        type: [
          {required: true, message: '请选择机构类型', trigger: 'blur'}
        ],
        sort: [
          {required: true, message: '请输入排序号', trigger: 'blur'}
        ]
      },
      deptList: [],  // 全部机构
      typeList: []  // 机构类型列表
    }
  },
  mounted() {
    this.query();
    this.querytype();  // 获取机构类型
  },
  methods: {
    /* 查询 */
    query() {
      this.loading = true;
      this.$http.get('/organization/index', {params: this.where}).then(res => {
        this.loading = false;
        if (res.data.code === 0) {
          this.data = this.$util.toTreeData(res.data.data, 'id', 'pid');
          setTimeout(() => {
            this.choose(this.data[0]);
          }, 100);
          if (Object.keys(this.where).length === 0) this.deptList = this.data;
        } else {
          this.$message.error(res.data.msg || '获取数据失败');
        }
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      });
    },
    /* 选择数据 */
    choose(row) {
      if (row != null) {
        this.current = row;
        this.$refs.orgTree.setCurrentKey(row.id);
      } else {
        this.current = null;
      }
    },
    /* 显示编辑 */
    edit() {
      this.editForm = Object.assign({}, this.current, {pid: this.current.pid || null});
      this.showEdit = true;
    },
    /* 保存编辑 */
    save() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({lock: true});
          this.$http.post('/dept/edit',
              Object.assign({}, this.editForm, {pid: this.editForm.pid || 0})
          ).then(res => {
            loading.close();
            if (res.data.code === 0) {
              this.showEdit = false;
              this.$message({type: 'success', message: res.data.msg});
              this.query();
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(e => {
            loading.close();
            this.$message.error(e.message);
          });
        } else {
          return false;
        }
      });
    },
    /* 删除 */
    remove() {
      this.$confirm('确定要删除选中的机构吗?', '提示', {type: 'warning'}).then(() => {
        const loading = this.$loading({lock: true});
        this.$http.delete('/dept/delete' + this.current.id).then(res => {
          loading.close();
          if (res.data.code === 0) {
            this.$message({type: 'success', message: res.data.msg});
            this.query();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(e => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => 0);
    },
    /* 查询机构类型 */
    querytype() {
      this.$http.get('/dictdata/getDictByCode', {
        params: {code: 'organization_type'}
      }).then(res => {
        if (res.data.code === 0) {
          this.typeList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      });
    }
  }
}
</script>

<style scoped>
.org-tree-group {
  border: 1px solid hsla(0, 0%, 60%, .15);
  height: calc(100vh - 262px);
  box-sizing: border-box;
}

.org-tree-group >>> .el-tree-node__content {
  height: 40px;
}

.org-tree-group >>> .el-tree-node__content > .el-tree-node__expand-icon {
  margin-left: 10px;
}
</style>